import React from 'react'
import PageFrontCustomMobile from './PageFrontCustomMobile'
import { FRONT, FRONT_MOBILE_SETTINGS } from '../constants/state'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'

const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT),
    frontMobileSetting: getData(state, FRONT_MOBILE_SETTINGS)
})

const PageFrontCustomMobileWrapper = ({
    location, 
    ads, 
    advertisements,
    movies, 
    moviesOrder,
    isMobile,
    highlights,
    siteHeaderData, 
    programOverviewStartviewType, 
    itemSelectionsDisplay, 
    sliderAppearance,
    itemSelections, 
    theme, 
    weischerAds,
    itemCollections, 
    overviewSubtitle,
    hasShowtimesFeature,
    hasGridTrailerFeature,
    hasGridHoverTrailer,
    mobileOverview,
    translation,
    routesData,
    stripeAppearance,
    highlightAppearance,
    smallSliderAppearance,
    showAvailableIn,
    programOverviewShowtimesType,
    features,
    isConnectedFast,
    //NEW REDUX STATE BELOW
    frontMobileSetting,
    cinemaDataFront
}) => {

    const { hide_no_performance_movies, overview_filter_movies_with_attribute } = cinemaDataFront
    const {customMobilePageActive, customMobilePageElements} = frontMobileSetting

    return (
        customMobilePageActive && <PageFrontCustomMobile
            isMobile={isMobile}
            location={location} 
            ads={ads} 
            advertisements={advertisements}
            stripeAppearance={stripeAppearance}
            hide_no_performance_movies={hide_no_performance_movies}
            overview_filter_movies_with_attribute={overview_filter_movies_with_attribute}
            highlightAppearance={highlightAppearance}
            showAvailableIn={showAvailableIn}
            smallSliderAppearance={smallSliderAppearance}
            overviewSubtitle={overviewSubtitle}
            highlights={highlights} 
            sliderAppearance={sliderAppearance}
            movies={movies} 
            moviesOrder={moviesOrder}
            siteHeaderData={siteHeaderData} 
            programOverviewStartviewType={programOverviewStartviewType} 
            itemSelectionsDisplay={itemSelectionsDisplay} 
            itemSelections={itemSelections} 
            theme={theme}
            hasShowtimesFeature={hasShowtimesFeature}
            hasGridTrailerFeature={hasGridTrailerFeature}
            hasGridHoverTrailer={hasGridHoverTrailer}
            weischerAds={weischerAds}
            itemCollections={itemCollections} 
            mobileOverview={mobileOverview}
            translation={translation}
            routesData={routesData}
            programOverviewShowtimesType={programOverviewShowtimesType}
            customMobilePageActive={customMobilePageActive}
            features={features}
            customMobilePageElements={customMobilePageElements}
            isConnectedFast={isConnectedFast}
        />
    )
}


export default compose(
    connect(mapStateToProps, null),
    toJS()
)(PageFrontCustomMobileWrapper)